import brazil from '@/data/verifyBusiness-BR';
import { ParentStep, Status } from '@/types/steps';

export interface VerifyBusinessState {
  readonly steps: readonly ParentStep<unknown>[];
  readonly statuses: Record<string, Status>;
}

export const initialState = {
  steps: brazil,
  statuses: {},
};

export enum VerifyBusinessActionType {
  statusesChanged = 'statusesChanged',
}

export interface VerifyBusinessActionBase {
  readonly type: VerifyBusinessActionType;
}

export interface VerifyBusinessStatusesChangedAction extends VerifyBusinessActionBase {
  readonly type: VerifyBusinessActionType.statusesChanged;
  readonly payload: Record<string, Status>;
}

export type VerifyBusinessAction = VerifyBusinessStatusesChangedAction;

export const verifyBusinessReducer = (
  state: VerifyBusinessState,
  action: VerifyBusinessAction,
): VerifyBusinessState => {
  switch (action.type) {
    case VerifyBusinessActionType.statusesChanged:
      return {
        ...state,
        statuses: { ...state.statuses, ...action.payload },
      };
    default:
      return state;
  }
};

export const statusesChanged = (statuses: Record<string, Status>): VerifyBusinessAction => ({
  type: VerifyBusinessActionType.statusesChanged,
  payload: statuses,
});
